import { useEffect, useState } from 'react';
import "react-multi-carousel/lib/styles.css";
import Select from 'react-select';
import {
  Typography
} from "@material-tailwind/react";
import { get } from 'lodash';
import 'swiper/css';
import 'swiper/css/navigation';
import ApiService from 'utills/ApiService';
import Pagination from "components/wps/Pagination";
import toast from 'react-hot-toast';
import '../overview.scss';
import { SelectorIcon, SortAscendingIcon, SortDescendingIcon } from '@heroicons/react/solid';

// Icon sort
const SortIcon = ({ field, sortBy, order }: { field: string, sortBy: string, order: string }) => {
  const isActive = sortBy === field;

  if (!isActive) {
    return <SelectorIcon className="w-[16px] h-[16px] ml-[4px] text-gray-400 cursor-pointer" />;
  }

  if (order === 'asc') {
    return <SortAscendingIcon className="w-[16px] h-[16px] ml-[4px] text-[#6366f1] cursor-pointer" />;
  }

  return <SortDescendingIcon className="w-[16px] h-[16px] ml-[4px] text-[#6366f1] cursor-pointer" />;
};

const SORT_FIELDS = ['subtotal', 'transactions', 'total_items', 'grand_total', 'discount_coupon', 'discount_promotion'];

const OverviewEvent = (props: any) => {
  const { translate, isMobile, applyDate, setLoading, page, setPage, setFilter, filter, shortenNumber, language, setEventSelected, setEventID, eventID, eventStatus, setEventStatus, navigate, symbolCurrency, currentCurrency, ticketPlatform, LightTooltip, token } = props;
  const [paging, setPaging] = useState(null as any);
  const [orders, setOrders] = useState([] as any);

  // --- NEW STATE ---
  const [sortBy, setSortBy] = useState('');
  const [order, setOrder] = useState<'asc' | 'desc'>('desc');

  // Options cho sort field
  const sortFieldOptions = [
    { value: '', label: translate('default') },
    { value: 'subtotal', label: translate('gross-revenue') },
    { value: 'transactions', label: translate('order') },
    { value: 'total_items', label: translate('items') },
    { value: 'discount_coupon', label: translate('discounts') },
    { value: 'discount_promotion', label: translate('discount-payment-gateway') },
    { value: 'grand_total', label: translate('real-revenue') },
  ] as any;

  // Options cho sort order
  const sortOrderOptions = [
    { value: 'desc', label: translate('descending') },
    { value: 'asc', label: translate('ascending') },
  ] as any;

  const status = [
    { value: '', label: translate('event-status') },
    { value: 'coming_soon', label: translate('coming-soon') },
    { value: 'closed', label: translate('closed') },
    { value: 'on_selling', label: translate('on-selling') }
  ] as any;

  const [events, setEvents] = useState([] as any);
  const [fetchData, setFetchData] = useState(false);
  const [statusSelected, setStatusSelected] = useState(null as any);
  const [eventDefault, setEventDefault] = useState(null as any);

  useEffect(() => {
    if (events?.length > 0) {
      if (eventID !== '') {
        events.forEach((item: any) => {
          if (item.value === eventID) setEventDefault(item);
        })
      } else {
        setEventDefault(events[0]);
      }
    }
  }, [eventID, events]);

  useEffect(() => {
    if (eventStatus !== '') {
      status.forEach((item: any) => {
        if (eventStatus === item.value) setStatusSelected(item);
      })
    } else {
      setStatusSelected(status[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventStatus]);

  useEffect(() => {
    if (filter) {
      const intervalFetchData = setInterval(() => {
        setFetchData(true);
        clearInterval(intervalFetchData);
      }, 100);
    }
  }, [filter]);

  useEffect(() => {
    if (fetchData) {
      if (events.length === 0) {
        fetchEventList();
      } else {
        if (page === 0) setPage(1);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [events, fetchData]);

  const fetchEventList = async () => {
    try {
      const result = await ApiService.get(`events`, token);
      if (result) {
        const arr = result.map((item: any) => ({
          value: item.id,
          label: get(item, `name_${language}`, '')
        }));
        setEvents(arr);
        setPage(1);
      }
    } catch (error: any) {
      console.log("Fetch event list failed:", error.message);
      setLoading(false);
    }
  }

  useEffect(() => {
    if (page > 0 && filter && applyDate?.start && applyDate?.end) {
      fetchOrders();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, filter, applyDate]);

const fetchOrders = async () => {
  if (!applyDate?.start || !applyDate?.end) return; // guard

  setLoading(true);
  try {
    const sortQuery = sortBy ? `&sort_by=${sortBy}&order=${order}` : '';
    const result = await ApiService.get(
      `orders/sales/page/${page}?from_date=${applyDate.start}&to_date=${applyDate.end}&event_id=${eventID}&event_status=${eventStatus}&limit=10&currency=${currentCurrency}&ticket_platform=${ticketPlatform}${sortQuery}`,
      token
    );
    if (result) {
      setPaging({ ...result.paging });
      setOrders(result.data);
      setFilter(false);
    }
  } catch (error: any) {
    console.log("Fetch orders sales failed:", error.message);
  }
  setFetchData(false);
  setLoading(false);
};
  // --- HANDLER KHI CLICK HEADER ĐỂ SORT ---
  const handleSort = (field: string) => {
    if (!SORT_FIELDS.includes(field)) return;

    let newSortBy = field;
    let newOrder: 'asc' | 'desc' = 'desc';

    if (sortBy === field) {
      if (order === 'desc') {
        // desc -> asc
        newOrder = 'asc';
        newSortBy = field;
      } else {
        // asc -> mặc định
        newSortBy = '';
        newOrder = 'desc'; // reset về default, giá trị này không dùng vì sortBy = ''
      }
    }
    // sortBy !== field -> mặc định -> desc (newSortBy = field, newOrder = 'desc')

    setSortBy(newSortBy);
    setOrder(newOrder);
    setPage(0);
    setFilter(true);
  };
  // ------------------------------------------

  const handleExportData = async () => {
    setLoading(true);
    const wsCurrency = localStorage.getItem('wsCurrency');
    const currentCurrency = (wsCurrency && wsCurrency !== '') ? wsCurrency : 'vnd';
    try {
      const result = await ApiService.get(
        `exports/event?from_date=${applyDate.start}&to_date=${applyDate.end}&event_id=${eventID}&event_status=${eventStatus}&currency=${currentCurrency}&ticket_platform=${ticketPlatform}`,
        token
      );
      if (result) toast.success(translate('export-success'));
    } catch (error: any) {
      toast.error(error.message);
    }
    setLoading(false);
  }

  // Helper render th có sort
  const SortableTh = ({ field, label }: { field: string, label: string }) => (
    <th className='p-4 cursor-pointer select-none' onClick={() => handleSort(field)}>
      <Typography
        variant="small"
        className="!font-500 flex items-center"
        placeholder="Typography"
        onPointerEnterCapture="none" onPointerLeaveCapture="none"
        onResize={() => {}} onResizeCapture={() => {}}
      >
        {label}
        <SortIcon field={field} sortBy={sortBy} order={order} />
      </Typography>
    </th>
  );

  return (
    <div className={`w-full ${isMobile ? 'my-[16px]' : 'bg-white rounded-[8px] my-[8px] '}`} id="event-overview">
      <div className={`${isMobile ? 'w-full bg-white border-b border-gray-200' : 'h-[80px] border-b border-[#e9ecff] px-[22px] flex items-center justify-between'} w-full`}>
        <div className={`${isMobile ? 'w-full p-[16px] text-14 font-700 border-b border-[#e9ecff]' : 'w-[100px] text-16 font-700'}`}>{translate("event")}</div>

        <div className={`${isMobile ? 'grid grid-cols-1 gap-[12px] p-[16px]' : 'flex-1 flex items-center justify-end gap-x-[12px]'}`}>
          {events.length > 0 && (
            <div className={`${isMobile ? 'w-full' : 'w-[calc(60%-85px)] max-w-[400px]'}`}>
              <div className="text-14 font-500 mb-[4px]">{translate("event-name")}</div>
              {eventDefault && (
                <Select
                  styles={{ input: (base) => ({ ...base, "input:focus": { boxShadow: "none" } }) }}
                  defaultValue={eventDefault}
                  name="events"
                  options={events}
                  className="text-14"
                  classNamePrefix="select"
                  placeholder={events[0].label}
                  onChange={(e: any) => {
                    setEventSelected(e.value);
                    setEventID(e.value);
                    setFilter(true);
                    setPage(0);
                  }}
                />
              )}
            </div>
          )}

          <div className={`${isMobile ? "w-full" : "w-[calc(40%-85px)] max-w-[208px]"}`}>
            <div className="text-14 font-500 mb-[4px]">{translate("status")}</div>
            {statusSelected && (
              <Select
                styles={{ input: (base) => ({ ...base, "input:focus": { boxShadow: "none" } }) }}
                defaultValue={statusSelected}
                name="events"
                options={status}
                className="text-14"
                classNamePrefix="select"
                placeholder={status[0].label}
                onChange={(e: any) => {
                  setEventStatus(e.value);
                  setFilter(true);
                  setPage(0);
                }}
              />
            )}
          </div>
          {/* Sort by field */}
          <div className={`${isMobile ? 'w-full' : 'hidden'}`}>
            <div className="text-14 font-500 mb-[4px]">{translate('sort-by')}</div>
            <Select
              styles={{ input: (base) => ({ ...base, "input:focus": { boxShadow: "none" } }) }}
              value={sortFieldOptions.find((o: any) => o.value === sortBy) || sortFieldOptions[0]}
              name="sort-by"
              options={sortFieldOptions}
              className="text-14"
              classNamePrefix="select"
              onChange={(e: any) => {
                setSortBy(e.value);
                setOrder('desc'); // reset order về desc khi đổi field
                setPage(0);
                setFilter(true);
              }}
            />
          </div>

          {/* Sort order - chỉ hiện khi đã chọn field */}
          {
            sortBy !== '' &&
            <div className={`${isMobile ? 'w-full' : 'hidden'}`}>
              <div className="text-14 font-500 mb-[4px]">{translate('order')}</div>
              <Select
                styles={{ input: (base) => ({ ...base, "input:focus": { boxShadow: "none" } }) }}
                value={sortOrderOptions.find((o: any) => o.value === order)}
                name="sort-order"
                options={sortOrderOptions}
                className="text-14"
                classNamePrefix="select"
                onChange={(e: any) => {
                  setOrder(e.value);
                  setPage(0);
                  setFilter(true);
                }}
              />
            </div>
          }
          <div
            className={`${isMobile ? 'w-[100%]' : 'w-[146px] ml-[10px] mt-[25px]'} h-[38px] rounded-[4px] border-[1px] border-[#A6A1FD] flex items-center justify-center cursor-pointer text-[#081774] btn-export-group`}
            onClick={handleExportData}
          >
            <img src="/images/icons/icon-download.svg" className="mr-[4px]" alt="icon-download" />
            <div className="text-[14px]">{translate('export-report')}</div>
          </div>
        </div>
      </div>

      <div className={`text-14 px-[22px] py-[24px] ${isMobile && "bg-white"}`}>
        {!isMobile ? (
          <div className='h-full w-full overflow-scroll overflow-y-hidden'>
            <table className="w-full min-w-max table-auto text-left">
              <thead className='bg-[#e9ecff]'>
                <tr>
                  {/* Cột không sort */}
                  <th className='p-4 stt'>
                    <Typography variant="small" className="!font-500" placeholder="Typography"
                      onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => {}} onResizeCapture={() => {}}>
                      {translate('no')}
                    </Typography>
                  </th>
                  <th className='p-4 event-name'>
                    <Typography variant="small" className="!font-500" placeholder="Typography"
                      onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => {}} onResizeCapture={() => {}}>
                      {translate('event')}
                    </Typography>
                  </th>

                  {/* Các cột có sort */}
                  <SortableTh field="subtotal"            label={translate('gross-revenue')} />
                  <SortableTh field="transactions"        label={translate('order')} />
                  <SortableTh field="total_items"         label={translate('items')} />
                  <SortableTh field="discount_coupon"     label={translate('discounts')} />
                  <SortableTh field="discount_promotion"  label={translate('discount-payment-gateway')} />
                  <SortableTh field="grand_total"         label={translate('real-revenue')} />

                  {/* Cột status không sort */}
                  <th className='p-4'>
                    <Typography variant="small" className="!font-500" placeholder="Typography"
                      onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => {}} onResizeCapture={() => {}}>
                      {translate('status')}
                    </Typography>
                  </th>
                </tr>
              </thead>
              <tbody>
                {orders.length > 0 && orders.map((item: any, index: number) => (
                  <tr key={`order_${item.event_id}_${index}`} className='table-row'>
                    <td className="w-[56px] pl-[16px]">
                      <Typography variant="small" placeholder="Typography"
                        onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => {}} onResizeCapture={() => {}}>
                        {index < 9 && <span>{paging.current_page - 1}{index + 1}</span>}
                        {index === 9 && <span>{paging.current_page}0</span>}
                      </Typography>
                    </td>
                    <td className="w-[222px]">
                      <Typography variant="small" placeholder="Typography"
                        onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => {}} onResizeCapture={() => {}}
                        className='event-name'
                        onClick={() => { setEventSelected(item.event_id); navigate(window.location.pathname, { replace: true }); }}>
                        {item.event_name}
                      </Typography>
                    </td>
                    <td className='p-4'>
                      <Typography variant="small" placeholder="Typography"
                        onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => {}} onResizeCapture={() => {}}>
                        <LightTooltip title={`${symbolCurrency} ${(+item.subtotal > 0) ? item.subtotal.toLocaleString('de-DE') : item.subtotal}`} placement='top-start'>
                          <span className="cursor-pointer">{symbolCurrency} {shortenNumber(item.subtotal)}</span>
                        </LightTooltip>
                      </Typography>
                    </td>
                    <td className='p-4'>
                      <Typography variant="small" placeholder="Typography"
                        onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => {}} onResizeCapture={() => {}}>
                        <LightTooltip title={`${(+item.transactions > 0) ? item.transactions.toLocaleString('de-DE') : item.transactions}`} placement='top-start'>
                          <span className="cursor-pointer">{shortenNumber(item.transactions, 'number')}</span>
                        </LightTooltip>
                      </Typography>
                    </td>
                    <td className='p-4'>
                      <Typography variant="small" color="blue-gray" className="font-normal" placeholder="Typography"
                        onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => {}} onResizeCapture={() => {}}>
                        <LightTooltip title={`${(+item.total_items > 0) ? item.total_items.toLocaleString('de-DE') : item.total_items}`} placement='top-start'>
                          <span className="cursor-pointer">{shortenNumber(item.total_items, 'number')}</span>
                        </LightTooltip>
                      </Typography>
                    </td>
                    <td className='p-4'>
                      <Typography variant="small" color="blue-gray" className="font-normal" placeholder="Typography"
                        onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => {}} onResizeCapture={() => {}}>
                        <LightTooltip title={`${symbolCurrency} ${(+item.discount_coupon > 0) ? item.discount_coupon.toLocaleString('de-DE') : item.discount_coupon}`} placement='top-start'>
                          <span className="cursor-pointer">{symbolCurrency} {shortenNumber(item.discount_coupon)}</span>
                        </LightTooltip>
                      </Typography>
                    </td>
                    <td className='p-4'>
                      <Typography variant="small" color="blue-gray" className="font-normal" placeholder="Typography"
                        onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => {}} onResizeCapture={() => {}}>
                        <LightTooltip title={`${symbolCurrency} ${(+item.discount_promotion > 0) ? item.discount_promotion.toLocaleString('de-DE') : item.discount_promotion}`} placement='top-start'>
                          <span className="cursor-pointer">{symbolCurrency} {shortenNumber(item.discount_promotion)}</span>
                        </LightTooltip>
                      </Typography>
                    </td>
                    <td className='p-4'>
                      <Typography variant="small" color="blue-gray" className="font-normal" placeholder="Typography"
                        onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => {}} onResizeCapture={() => {}}>
                        <LightTooltip title={`${symbolCurrency} ${(+item.grand_total > 0) ? item.grand_total.toLocaleString('de-DE') : item.grand_total}`} placement='top-start'>
                          <span className="cursor-pointer">{symbolCurrency} {shortenNumber(item.grand_total)}</span>
                        </LightTooltip>
                      </Typography>
                    </td>
                    <td className='p-4'>
                      {item.selling_type === 'on_selling' && <div className="max-w-[110px] flex items-center justify-center text-12 font-600 rounded-[100px] px-[12px] py-[4px] text-[#a16207] bg-[#fef9c3]">{translate('opening')}</div>}
                      {item.selling_type === 'closed' && <div className="max-w-[110px] flex items-center justify-center text-12 font-600 rounded-[100px] px-[12px] py-[4px] text-[#be189c] bg-[#ffdaef]">{translate('closed')}</div>}
                      {item.selling_type === 'coming_soon' && <div className="max-w-[110px] flex items-center justify-center text-12 font-600 rounded-[100px] px-[12px] py-[4px] text-[#7e22d7] bg-[#f3e8ff]">{translate('coming')}</div>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          // Mobile layout giữ nguyên, không thay đổi
          <div className="w-full grid grid-cols-1 gap-[12px]">
            {orders.length > 0 && orders.map((item: any, index: number) => (
              <div
                className="w-full bg-white p-[16px] rounded-[4px] grid grid-cols-1 gap-[12px]"
                key={`event_${item.id}_${index}`}
                style={{ boxShadow: "0 0 0 1px rgba(17, 24, 39, 0.05), 0 4px 8px rgba(0, 0, 0, 0.1)" }}
              >
                <div className="w-full flex items-start gap-x-[8px]">
                  <div className="w-[134px] text-14 font-500">{translate('no')}</div>
                  <div className="text-14 flex-1">{index + 1}</div>
                </div>
                <div className="w-full flex items-start gap-x-[8px]">
                  <div className="w-[134px] text-14 font-500">{translate('status')}</div>
                  <div className="text-14 flex-1">
                    {item.selling_type === 'on_selling' && <div className="max-w-[110px] flex items-center justify-center text-12 font-600 rounded-[100px] px-[12px] py-[4px] text-[#a16207] bg-[#fef9c3]">{translate('opening')}</div>}
                    {item.selling_type === 'closed' && <div className="max-w-[110px] flex items-center justify-center text-12 font-600 rounded-[100px] px-[12px] py-[4px] text-[#be189c] bg-[#ffdaef]">{translate('closed')}</div>}
                    {item.selling_type === 'coming_soon' && <div className="max-w-[110px] flex items-center justify-center text-12 font-600 rounded-[100px] px-[12px] py-[4px] text-[#7e22d7] bg-[#f3e8ff]">{translate('coming')}</div>}
                  </div>
                </div>
                <div className="w-full flex items-start gap-x-[8px]">
                  <div className="w-[134px] text-14 font-500">{translate('event')}</div>
                  <div className="text-14 flex-1">{item.event_name}</div>
                </div>
                <div className="w-full flex items-start gap-x-[8px]">
                  <div className="w-[134px] text-14 font-500">{translate('gross-revenue')}</div>
                  <div className="text-14 flex-1">{symbolCurrency} {shortenNumber(item.subtotal)}</div>
                </div>
                <div className="w-full flex items-start gap-x-[8px]">
                  <div className="w-[134px] text-14 font-500">{translate('order')}</div>
                  <div className="text-14 flex-1">{item.transactions}</div>
                </div>
                <div className="w-full flex items-start gap-x-[8px]">
                  <div className="w-[134px] text-14 font-500">{translate('items')}</div>
                  <div className="text-14 flex-1">{item.total_items}</div>
                </div>
                <div className="w-full flex items-start gap-x-[8px]">
                  <div className="w-[134px] text-14 font-500">{translate('discounts')}</div>
                  <div className="text-14 flex-1">{symbolCurrency} {shortenNumber(item.discount_coupon)}</div>
                </div>
                <div className="w-full flex items-start gap-x-[8px]">
                  <div className="w-[134px] text-14 font-500">{translate('promotion')}</div>
                  <div className="text-14 flex-1">{symbolCurrency} {shortenNumber(item.discount_promotion)}</div>
                </div>
              </div>
            ))}
          </div>
        )}

        {paging && (
          <div className={`board__bottom ${isMobile ? 'mt-[16px]' : 'pagination-desktop'}`}>
            {paging.total_page > 1 && (
              <Pagination setPage={setPage} paging={paging} setFilter={setFilter} />
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default OverviewEvent;